import { CandidateType } from '../Candidates/Candidates';
import { formatNumberAsCurrency, roundNumberToHundredths } from 'helpers/utils';
import {
  MAX_DONATION,
  MIN_DONATION_PER_CANDIDATE,
  getContributionLimitNumber,
} from 'helpers/donate';

export const getOnChangeCandidateAmount =
  (
    candidates: CandidateType[],
    setCandidates: (candidates: CandidateType[]) => void,
    setDonationTotal: (donationTotal: number) => void,
    isSelectedUpdated?: boolean
  ) =>
  (candidate: CandidateType, amount = 0, index: number) => {
    const updatedCandidates = [...candidates];
    updatedCandidates[index] = {
      ...updatedCandidates[index],
      donationAmount: amount >= 0 ? amount : 0,
      ...(isSelectedUpdated && { isSelected: amount > 0 }),
    };
    const updatedTotal = updatedCandidates.reduce(
      (total, candidate) => total + (candidate.donationAmount || 0),
      0
    );

    setCandidates(updatedCandidates);
    setDonationTotal(roundNumberToHundredths(updatedTotal));
  };

export const getAmountValidation = (candidate: CandidateType, maxDonation = MAX_DONATION) => {
  const contributionLimit = getContributionLimitNumber(candidate);

  // Pure validator so the error reflects the current amount whether it was set
  // by user or programmatically (e.g. on "Split" button click)
  const validate = (amount?: number): string | undefined => {
    if (!amount) {
      return undefined;
    }
    let errorStr: string | undefined;
    if (contributionLimit !== null && amount > contributionLimit) {
      errorStr = 'Please enter a lower amount.';
    }
    if (amount > maxDonation) {
      errorStr = `Please contact support if you would like to donate ${formatNumberAsCurrency(
        maxDonation
      )} or more.`;
    }
    if (amount && amount < MIN_DONATION_PER_CANDIDATE) {
      errorStr = `Amount must be greater than ${formatNumberAsCurrency(
        MIN_DONATION_PER_CANDIDATE
      )}.`;
    }
    return errorStr;
  };

  return {
    validationError: validate(candidate.donationAmount),
    validate,
  };
};
